import React from 'react';
import './styles/Header.css';

const Header = ({ onMenuToggle, currentBoardNum }) => {
    return (
        <header className="header-row">
            <div className="header-title-group">
                <h1 className="header-title">Da Combos</h1>
                {currentBoardNum ? <p className="header-subtitle">Board #{currentBoardNum}</p> : null}
            </div>
            <button className="header-hamburger" onClick={onMenuToggle} aria-label="Open board menu">
                <span />
                <span />
                <span />
            </button>
        </header>
    );
};

export default Header;